var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import EssentialInformation from '~/components/collection-execution/collection-case-info/essential-information.vue';
import CustInfo from '~/components/collection-execution/collection-case-info/cust-info.vue';
import ProductInfo from '~/components/collection-execution/collection-case-info/product-info.vue';
import ApplyDatumInfo from '~/components/collection-execution/collection-case-info/apply-datum-info.vue';
import CreditReport from '~/components/collection-execution/collection-case-info/credit-report.vue';
import PublicDebtInfo from '~/components/collection-execution/collection-case-info/public-debt-info.vue';
import FixInfo from '~/components/collection-execution/collection-case-info/fix-info.vue';
import CaseInfo from '~/components/collection-execution/collection-case-info/case-info.vue';
var CollectionCaseInfo = /** @class */ (function (_super) {
    __extends(CollectionCaseInfo, _super);
    function CollectionCaseInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 默认激活页面
        _this.activeName = 'essential-information';
        return _this;
    }
    CollectionCaseInfo = __decorate([
        Component({
            components: {
                CustInfo: CustInfo,
                ProductInfo: ProductInfo,
                ApplyDatumInfo: ApplyDatumInfo,
                CreditReport: CreditReport,
                PublicDebtInfo: PublicDebtInfo,
                FixInfo: FixInfo,
                CaseInfo: CaseInfo,
                EssentialInformation: EssentialInformation
            },
        })
    ], CollectionCaseInfo);
    return CollectionCaseInfo;
}(Vue));
export default CollectionCaseInfo;
